// eslint-disable-next-line import/no-extraneous-dependencies
import { handleActions } from 'redux-actions';

import * as Actions from './actions';

const initialState = {
  isGetAllShippingsRequest: false,
  isGetAllShippingsSuccess: false,
  isGetAllShippingsFailure: false,
  getAllShippingsState: {},
  //
  isCreateShippingRequest: false,
  isCreateShippingSuccess: false,
  isCreateShippingFailure: false,
  //
  isUpdateShippingRequest: false,
  isUpdateShippingSuccess: false,
  isUpdateShippingFailure: false,
  //
  isDeleteShippingRequest: false,
  isDeleteShippingSuccess: false,
  isDeleteShippingFailure: false,
  //
  errorMessages: [],
};

const reducer = handleActions(
  {
    // #region : Get all types
    [Actions.getAllShippingsRequest]: (state) => ({
      ...state,
      isGetAllShippingsRequest: true,
      isGetAllShippingsSuccess: false,
      isGetAllShippingsFailure: false,
    }),
    [Actions.getAllShippingsSuccess]: (state, { payload }) => ({
      ...state,
      isGetAllShippingsRequest: false,
      isGetAllShippingsSuccess: true,
      isGetAllShippingsFailure: false,
      getAllShippingsState: payload,
    }),
    [Actions.getAllShippingsFailure]: (state, { payload }) => ({
      ...state,
      isGetAllShippingsRequest: false,
      isGetAllShippingsSuccess: false,
      isGetAllShippingsFailure: true,
      errorMessages: payload,
    }),
    // #endregion
    // #region : Create type
    [Actions.createShippingRequest]: (state) => ({
      ...state,
      isCreateShippingRequest: true,
      isCreateShippingSuccess: false,
      isCreateShippingFailure: false,
    }),
    [Actions.createShippingSuccess]: (state, { payload }) => ({
      ...state,
      isCreateShippingRequest: false,
      isCreateShippingSuccess: true,
      isCreateShippingFailure: false,
      getAllShippingsState: {
        ...state.getAllShippingsState,
        data: [...state.getAllShippingsState.data, payload.data],
      },
    }),
    [Actions.createShippingFailure]: (state, { payload }) => ({
      ...state,
      isCreateShippingRequest: false,
      isCreateShippingSuccess: false,
      isCreateShippingFailure: true,
      errorMessages: payload,
    }),
    [Actions.resetCreateShippingState]: (state) => ({
      ...state,
      isCreateShippingRequest: false,
      isCreateShippingSuccess: false,
      isCreateShippingFailure: false,
      errorMessages: [],
    }),
    // #endregion
    // #region : Update type
    [Actions.updateShippingRequest]: (state) => ({
      ...state,
      isUpdateShippingRequest: true,
      isUpdateShippingSuccess: false,
      isUpdateShippingFailure: false,
    }),
    [Actions.updateShippingSuccess]: (state) => ({
      ...state,
      isUpdateShippingRequest: false,
      isUpdateShippingSuccess: true,
      isUpdateShippingFailure: false,
    }),
    [Actions.updateShippingFailure]: (state, { payload }) => ({
      ...state,
      isUpdateShippingRequest: false,
      isUpdateShippingSuccess: false,
      isUpdateShippingFailure: true,
      errorMessages: payload,
    }),
    [Actions.resetUpdateShippingState]: (state) => ({
      ...state,
      isUpdateShippingRequest: false,
      isUpdateShippingSuccess: false,
      isUpdateShippingFailure: false,
      errorMessages: [],
    }),
    // #endregion
    // #region : Delete type
    [Actions.deleteShippingRequest]: (state) => ({
      ...state,
      isDeleteShippingRequest: true,
      isDeleteShippingSuccess: false,
      isDeleteShippingFailure: false,
    }),
    [Actions.deleteShippingSuccess]: (state, { payload }) => ({
      ...state,
      isDeleteShippingRequest: false,
      isDeleteShippingSuccess: true,
      isDeleteShippingFailure: false,
      getAllShippingsState: {
        ...state.getAllShippingsState,
        data: [...state.getAllShippingsState.data.filter((item) => item.id !== payload)],
      },
    }),
    [Actions.deleteShippingFailure]: (state, { payload }) => ({
      ...state,
      isDeleteShippingRequest: false,
      isDeleteShippingSuccess: false,
      isDeleteShippingFailure: true,
      errorMessages: payload,
    }),
    [Actions.resetDeleteShippingState]: (state) => ({
      ...state,
      isDeleteShippingRequest: false,
      isDeleteShippingSuccess: false,
      isDeleteShippingFailure: false,
      errorMessages: [],
    }),
    // #endregion
    // #region : Reset
    [Actions.resetShippingState]: () => initialState,
    // #endregion
  },
  initialState,
);

export default reducer;
